import Button from './Button.vue';

export default Button;



// WEBPACK FOOTER //
// ./src/components/parts/competences/card/components/btn/index.ts